export default __webpack_public_path__ + "static/media/icon_info.64db960c.svg";